import { useTranslation } from 'react-i18next';
import { PyEntityCreationModal } from '../PyEntityCreationModal';
import CreateContactForm, { initialFormValues } from './CreateContactForm';
import CreateContactFormDeprecated, { initialFormValuesDeprecated } from './CreateContactFormDeprecated';
import { useCreateContact } from 'pages/editor/useCreateContact';
import useFeatureFlag from 'hooks/useFeatureFlag';
import { FeatureFlags } from 'utils/featureFlags';
import type { ContactEntity } from 'services/entities/ContactEntity';
import type { ContactsControllerCreateContactMutationRequest, ContactResponse } from '@proposify/document-service-api-schema';
import type { CompanyId, MigrationCompanyId } from '../../../../services/entities/MigrationEntities.ts';
interface CreateContactModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: (payload: { data: ContactEntity | ContactResponse; formData: ContactsControllerCreateContactMutationRequest }) => void;
  companyName?: string;
  companyId: MigrationCompanyId | null;
  existingEmails?: string[];
}

export default function CreateContactModal({
  isOpen,
  onClose,
  onSuccess,
  companyName,
  companyId,
  existingEmails = [],
}: CreateContactModalProps) {
  const { t } = useTranslation();
  const { mutateAsync } = useCreateContact();
  const featureFlags = useFeatureFlag([FeatureFlags.useVariablesBff]);
  const isNewForm = featureFlags[FeatureFlags.useVariablesBff];

  const FormComponent = isNewForm ? CreateContactForm : CreateContactFormDeprecated;
  const baseFormValues = isNewForm ? initialFormValues : initialFormValuesDeprecated;

  const formValuesWithCompany = {
    ...baseFormValues,
    companies: companyId ? [{ id: companyId as CompanyId }] : [],
    useCompanyAddress: !!companyId,
  };

  return (
    <PyEntityCreationModal
      isOpen={isOpen}
      onClose={onClose}
      onSuccess={onSuccess}
      title={companyName ? `${t('document.create_contact.title')} ${companyName}` : t('document.create_contact.title_no_company')}
      description={t('document.create_contact.description')}
      cancelText={t('document.create_company.cancel')}
      saveText={t('document.create_company.save')}
      FormComponent={FormComponent}
      formProps={{ existingEmails }}
      initialFormData={formValuesWithCompany}
      mutationFn={mutateAsync}
      invalidateQueries={[['contacts']]}
      successNotification={{
        title: t('document.create_contact.notification.success.title'),
        description: t('document.create_contact.notification.success.description'),
      }}
      errorNotification={{
        title: t('document.create_company.notification.errors.save_error_title'),
        description: t('document.create_company.notification.errors.save_error_description'),
      }}
    />
  );
}
